const al = {
    translation: {
        Welcome: "Mirë se erdhët",
        LoggedIn: "U identifikuat me sukses ✅",
        NotLoggedIn: "Nuk jeni i identifikuar ❌",
        Login: "Identifikohu",
        Logout: "Dil",
        Home: "Kryefaqja",
        en: "Anglisht (English)",
        al: "Shqip",
        SigningIn: "Po identifikoheni…",
        RedirectToLogin: "Po ridrejtoheni te faqja e hyrjes…",
        LoggingOut: "Po dilni...",
        PleaseLoginToMenu: "Ju lutemi, identifikohuni për të parë menunë",
        PageNotFoundRedirect: "Faqja nuk u gjet. Po ridrejtoheni...",
        Page: "Faqe",
        Next: "Tjetër",
        Previous: "E mëparshme",
        Services: "Shërbime",
        ServiceList: "Lista e Shërbimeve",
        Loading: "Po ngarkohet...",
        Back: "Mbrapa",
        Create: "Krijo",
        Edit: "Përpuno",
        Details: "Detaje",
        Update: "Përditëso",
        Delete: "Fshi",
        PasswordResetType: "Rivendosje fjalëkalimi",
        PasswordResetMessage: "Fjalëkalimi u rivendos me sukses",
        OtpAssignedType: "OTP i caktuar",
        OtpAssignedMessage: "Aplikacioni OTP u caktua me sukses",
        OtpResetType: "Rivendosje OTP",
        OtpResetMessage: "Aplikacioni OTP u rivendos me sukses",
        Cancel: "Anulo",
        Actions: "Veprime",
        ProfileTypes: "Llojet e profileve",
        Save: "Ruaj",
        ClaimList: "Lista e kërkesave",
        PleaseUploadLibraryFile: "Ju lutemi ngarkoni skedarin kryesor të librarisë.",
        TransactionRouteIdMissing: "ID-ja e Rrugës së Transaksionit mungon në URL.",
        LibraryUploadSuccess: "Libraria u ngarkua me sukses!",
        LibraryUploadFailure: "Ngarkimi dështoi.",
        UploadLibrary: "Ngarko Librari",
        MainLibraryFile: "Skedari Kryesor i Librarisë",
        LibraryPath: "Rruga e Librarisë",
        Dependencies: "Varësi",
        SelectedFiles: "Skedarët e zgjedhur",
        Template: "Model",
        RemoveFile: "Hiq Skedarin",
        TransactionRoutes: "Rrugët transaksionesh",
        Upload: "Ngarko",
        Add: "Shto",
        Name: "Emri",
        Search: "Kërko",
        Reset: "Rivendos",
        Select: "Zgjidh",
        Library: "Libraria",
        Libraries: "Librari",
        LibrariesLinkedToTransactionRoute: "Libraritë e lidhura me Rrugën e Transaksionit",
        NoLibrariesFound: "Nuk u gjet asnjë librari.",
        ConfirmRemoveLibrary: "Jeni i sigurt që doni të hiqni librarinë '{{name}}' nga kjo rrugë transaksioni?",
        LibraryAssociationDeleted: "Lidhja me librarinë u fshi!",
        CouldNotFetchLibraryContents: "Nuk mund të merret përmbajtja e librarisë.",
        DeleteFailedWithStatus: "Fshirja dështoi. Statusi {{status}}",
        ConnectionError: "Gabim lidhjeje: {{error}}",
        GeneralError: "Gabim: {{error}}",
        AddLibrariesToTransactionRoute: "Shto Librari në Rrugën e Transaksionit",
        LibrariesSuccessfullyAdded: "Libraritë u shtuan me sukses.",
        CouldNotFetchSyncStatus: "Nuk mund të merret statusi i sinkronizimit.",
        SyncStatus: "Statusi i sinkronizimit",
        SyncStatusFor: "Statusi i sinkronizimit për {{libraryPath}}",
        DatabaseSyncStatus: "Statusi i sinkronizimit të bazës së të dhënave",
        AllFilesInSync: "Të gjithë skedarët janë të sinkronizuar.",
        DiscrepanciesFound: "U gjetën mospërputhje.",
        MissingInTransformation: "Mungon në Transformation",
        ExtraInTransformation: "Ekstra në Transformation",
        HashMismatches: "Mospërputhje hash",
        PrimarySite: "Sajti kryesor",
        AllFilesPresent: "Të gjithë skedarët janë të pranishëm.",
        MissingFiles: "Skedarët që mungojnë",
        SyncPrimary: "Sinkronizo Primarin",
        BccSite: "Sajti BCC",
        SyncBcc: "Sinkronizo BCC",
        Sync: "Sinkronizo",
        SyncTriggered: "Sinkronizimi u nis me sukses.",
        SyncFailed: "Sinkronizimi dështoi.",
        NoDataAvailable: "Nuk ka të dhëna.",
        Close: "Mbyll",
        LibraryContents: "Përmbajtja e librarisë",
        NoLibrariesAvailable: "Nuk ka librari të disponueshme.",
        AddSelectedLibraries: "Shto Libraritë e Zgjedhura",
        AddLibraries: "Shto Librari",
        AreYouSureRemoveLibrary: "Jeni i sigurt që doni të hiqni librarinë '{{name}}'?",
        AddExistingLibrary: "Shto librari ekzistuese",
        CouldNotFetchClassName: "Nuk mund të merret Emri i Klasës për transactionId: {{id}}",
        CouldNotFetchServiceName: "Nuk mund të merret Emri i Shërbimit për serviceId: {{id}}",
        UploadSuccess: "Skedarët u ngarkuan me sukses!",
        UploadError: "Përditësimi i librarisë dështoi.",
        BadRequest: "Kërkesë e pavlefshme: {{error}}",
        ServiceDeleteSuccess: "Shërbimi u fshi me sukses!",
        ErrorWithError: "Ndodhi një gabim: {{error}}",
        StatusCode: "Kodi i statusit: {{code}}",
        LibraryPathRequired: "Rruga e librarisë është e detyrueshme.",
        LibraryUpdated: "Libraria u përditësua me sukses!",
        MainLibraryFileRequired: "Skedari kryesor i librarisë është i detyrueshëm.",
        LibraryPathCannotContainSpaces: "Rruga e librarisë nuk mund të përmbajë hapësira.",
        LibraryPathCannotStartOrEndWithSlash: "Rruga e librarisë nuk mund të fillojë ose mbarojë me shenjën / ose \\.",
        LibraryPathNoSpecialChars: "Rruga e librarisë nuk mund të përmbajë karaktere speciale.",
        NameExists: "Emri ekziston tashmë",
        CodeExists: "Kodi ekziston tashmë",
        InLibEditAllowed: "Lejohet përpunimi në librari",
        ClassNameExists: "Emri i klasës ekziston tashmë",
        UserId: "ID e Përdoruesit",
        IpAddress: "Adresa IP",
        ClientAppId: "ID e Aplikacionit Klient",
        ActionType: "Lloji i Veprimit",
        EntityType: "Lloji i Entitetit",
        SourceSystem: "Sistemi Burimor",
        AuditActionOtpEmailSent: "Kodi OTP u Dërgua (Email)",
        AuditActionOtpSmsSent: "Kodi OTP u Dërgua (SMS)",
        AuditActionOtpEmailCcSent: "Kodi OTP u Dërgua (Kopje Email)",
        AuditSourceNotifications: "Njoftimet",
        Reason: "Arsyeja",
        ClassName: "Emri i Klasës",
        CorrelationId: "ID-ja e Korrelacionit",
        Timestamp: "Vula kohore",
        CurrentStage: "Faza Aktuale",
        Changes: "Ndryshime",
        ErrorMessage: "Mesazhi i Gabimit",
        OldValue: "Vlera e vjetër",
        NewValue: "Vlera e re",
        AuditLogsList: "Lista e regjistrave të auditimit",
        AuditLogDetails: "Detajet e auditimit",
        LogId: "ID e regjistrit: {{id}}",
        DateFrom: "Data Nga",
        DateTo: "Data Deri",
        LatestLogs: "Regjistrat e fundit",
        SeeMore: "Shiko më shumë",
        ServiceDetails: "Detajet e Shërbimit",
        Code: "Kodi",
        TransactionName: "Emri i Transaksionit",
        ServiceSecurityImplicitType: "Lloji i Sigurisë së Shërbimit",
        ApprovedDelegation: "Delegim i Miratuar",
        ApprovedProfile: "Profili i Miratuar",
        CanBeDelegatedToAgent: "Mund të delegohet tek përfaqësuesi",
        ClientAgentCanSendSubmission: "Përfaqësuesi i klientit mund të dërgojë kërkesë",
        DelegationExpiresDays: "Skadimi i delegimit (ditë)",
        EnrollementAllowed: "Lejohet regjistrimi",
        IsVisible: "I dukshëm",
        MultipleEnrollementsAllowed: "Lejohen regjistrime të shumta",
        ProfileType: "Lloji i Profilit",
        RequireAuthentication: "Kërkon autentikim",
        SubmissionAllowed: "Lejohet dërgimi",
        WillBeActivatedAfterEnrollment: "Do të aktivizohet pas regjistrimit",
        AuditLogs: "Auditime",
        Id: "ID",
        ItemDeletionConfirmation: "Jeni i sigurt që doni të fshini elementin me emrin '{{selectedName}}'?",
        InstitutionDeletionConfirmation: "Jeni i sigurt që doni të fshini institucionin '{{selectedName}}'? Të gjitha shërbimet e tij, dhe të gjitha transaksionet e këtyre shërbimeve, do të fshihen gjithashtu.",
        ServiceDeletionConfirmation: "Jeni i sigurt që doni të fshini shërbimin '{{selectedName}}'? Të gjitha transaksionet e këtij shërbimi do të fshihen gjithashtu.",
        SelectTransactionRoutesForRestoration: "Zgjidh rrugët e transaksionit për t'i rikthyer me shërbimin",
        BreadcrumbServiceTransationRoutes: "{{ serviceName }}: Rrugë transaksionesh",
        BreadcrumbRouteLabelTransactionParameters: "{{ routeLabel }}: Parametrat e transaksionit",
        TransactionParameterDetails: "Detajet e Parametrit të transaksionit",
        ParameterType: "Lloji i parametrave",
        ParameterName: "Emri i parametrave",
        ParameterValue: "Vlera e parametrave",
        ParameterValueType: "Lloji i vlerës së parametrave",
        EditTransactionParameter: "Përpuno  Parametrin e transaksionit",
        CreateTransactionParameter: "Krijo parametër transaksioni",
        TransactionParametersList: "Lista e parametrave të transaksionit",
        CopyParameters: "Kopjo parametrat",
        SelectOption: "Zgjidh një opsion",
        SelectTransactionRoutesToCopyParameters: "Zgjidhni rrugën e transaksionit nga e cila do të kopjohen parametrat.",
        BackToTransactionRoutesList: "Kthehu te lista e rrugëve të transaksionit",
        BackToServicesList: "Kthehu te lista e shërbimeve",
        Location: "Vendndodhja",
        AccessTokenUrl: "URL e tokenit të aksesit",
        ServiceConsumingType: "Lloji i konsumimit të shërbimit",
        TransactionMethod: "Metoda e transaksionit",
        AuthenticationType: "Lloji i autentifikimit",
        RequestPayloadType: "Lloji i ngarkesës së kërkesës",
        RetryInterval: "Intervali i riprovimit",
        OperationType: "Lloji i operacionit",
        Enabled: "Aktiv",
        Disabled: "Joaktiv",
        Yes: "Po",
        No: "Jo",
        SpokeSubmissionOnly: "Vetëm përmes shërbimit spoke (me pagesë)",
        SpokeSubmissionOnlyHelp: "Kur zgjidhet, ky transaksion mund të konsumohet vetëm përmes shërbimit spoke dhe çdo thirrje matet për faturim. Të gjitha endpoint-et e tjera do ta refuzojnë.",
        TransationRouteDetails: "Detajet e rrugës së transaksionit",
        PostLocation: "Vendndodhja e dërgimit",
        Approve: "Mirato",
        ItemApproveConfirmation: "Jeni i sigurt që doni të miratoni këtë element me Emrin '{{selectedName}}'?",
        TransactionRouteList: "Lista e rrugëve të transaksionit",
        RouteLabel: "Etiketa e rrugës",
        Institutions: "Institucione",
        InstitutionList: "Lista e institucioneve",
        InstitutionDetails: "Detajet e institucionit",
        InstitutionDetailsWithName: "Detajet e institucionit {{institutionName}}",
        DataDifferences: "Dallimet e të dhënave",
        Transations: "Transaksione",
        Restore: "Rikthe",
        Parameters: "Parametra",
        ClaimLogicBuilder: "Ndërtuesi i Logjikës së Kërkesave",
        ServiceRestoredSuccessfully: "Shërbimi u rikthye me sukses",
        EditService: "Përpuno  Shërbimin",
        CreateService: "Krijo Shërbim",
        Institution: "Institucion",
        Attribute: "Atribut",
        Enrollement: "Regjistrim",
        Delegation: "Delegim",
        ServiceDeletedSuccessfully: "Shërbimi u fshi me sukses!",
        ServiceCreatedSuccessfully: "Shërbimi u krijua me sukses!",
        ServiceUpdatedSuccessfully: "Shërbimi u përditësua me sukses!",
        InstitutionUpdatedSuccessfully: "Institucioni u përditësua me sukses!",
        InstitutionCreatedSuccessfully: "Institucioni u krijua me sukses!",
        InstitutionDeletedSuccessfully: "Institucioni u fshi me sukses!",
        TransactionRouteUpdatedSuccessfully: "Rruga e transaksionit u përditësua me sukses!",
        TransactionRouteCreatedSuccessfully: "Rruga e transaksionit u krijua me sukses!",
        TransactionRouteDeletedSuccessfully: "Rruga e transaksionit u fshi me sukses!",
        TransactionRouteApprovedSuccessfully: "Rruga e transaksionit u miratua me sukses!",
        TransactionParameterUpdatedSuccessfully: "Parametri i transaksionit u përditësua me sukses!",
        TransactionParameterCreatedSuccessfully: "Parametri i transaksionit u krijua me sukses!",
        TransactionParameterDeletedSuccessfully: "Parametri i transaksionit u fshi me sukses!",
        TransactionParametersClonedSuccessfully: "Parametrat e transaksionit u kopjuan me sukses!",
        Required: "E detyrueshme",
        PleaseSubmitAValue: "Ju lutemi jepni një vlerë",
        DelegationExpiresDaysGEZero: "Ditët e skadimit të delegimit duhet të jenë ≥ 0",
        PleaseSubmitInstitution: "Ju lutemi, zgjidhni një institucion",
        EditTransactionRoute: "Përpuno rrugën e transaksionit",
        CreateTransactionRoute: "Krijo rrugë transaksioni",
        AuditLogList: "Lista e auditimit",
        EditInstitution: "Përpuno institucionin",
        CreateInstitution: "Krijo institucion",
        CopyTransactionParameters: "Kopjo parametrat e transaksionit",
        RouteName: "Emri i rrugës",
        SubmitAndCloseModal: "Dërgo dhe mbyll dritaren ({{selectedCount}} të zgjedhura)",
        Copy: "Kopjo",
        InstitutionIsNotEmpty: "Institucioni nuk mund të fshihet, të paktën një shërbim është i lidhur me të.",
        Claims: "Kërkesa",
        PredefinedTemplateClaims: "Kërkesa me model të paracaktuar",
        SwitchToMultiClaimMode: "Kalo në mënyrën me shumë kërkesa",
        SwitchToSingleClaimMode: "Kalo në mënyrën me një kërkesë",
        ResetBuilder: "Rivendos ndërtuesin",
        Preview: "Parashikim",
        JSONPreview: "Parashikim JSON",
        LogicType: "Lloji i logjikës",
        NegateCondition: "Mohoni këtë kusht (NOT)",
        Claim: "Kërkesë",
        Group: "Grup",
        RemoveGroup: "Hiq grupin",
        SetCustomValue: "Caktoni vlerë të personalizuar",
        Remove: "Hiq",
        ClaimSearchFailed: "Kërkimi i kërkesave dështoi: {{error}}",
        CanOnlySwitchToASingleClaim: "Mund të kaloni në një kërkesë vetëm nëse ekziston saktësisht një element fëmijë.",
        SelectPredefinedTemplateClaim: "Zgjidh kërkesë me model të paracaktuar",
        PredefinedTemplateClaimsFailed: "Kërkesat me model të paracaktuar dështuan: {{error}}",
        ErrorGettingTemplateClaimAndLogic: "Gabim në marrjen e kërkesës dhe logjikës së modelit: {{error}}",
        ErrorGettingAllClaims: "Gabim në marrjen e të gjitha kërkesave: {{error}}",
        MustUsedWithinToastProvider: "useToast duhet të përdoret brenda ToastProvider",
        PleaseFixValidationErrors: "Ju lutemi, rregulloni gabimet e vlefshmërisë para se të vazhdoni.",
        DeleteItem: "Jeni i sigurt që doni të fshini këtë element?",
        ClaimLogicAddSuccess: "Logjika e kërkesës u krijua me sukses për rrugën e transaksionit: {{transactionLabel}}!",
        ClaimLogicDeleteSuccess: "Logjika e kërkesës u fshi me sukses për rrugën e transaksionit: {{transactionLabel}}!",
        SyncInAWAndSAAddSuccess: "Sinkronizimi në databazat Admin Web dhe Service Aggregator u krijua me sukses!",
        SyncInAWAndSAAddFail: "Sinkronizimi në databazat Admin Web dhe Service Aggregator dështoi!",
        Type: "Lloji",
        Value: "Vlera",
        Scope: "Fusha veprimi",
        ClaimDataDifferences:  "Dallimet e të dhënave të kërkesave",
        SyncWithDatabase: "Jeni i sigurt që doni të sinkronizoni këto të dhëna në bazën e të dhënave?",
        SyncInDatabases: "Sinkronizo në baza të dhënash",
        NoDataDifferencesFoundBetweenAWAndKeycloak: "Nuk u gjetën dallime të dhënash mes Admin Web dhe Keycloak.",
        RefreshError: "Gabim gjatë rifreskimit",
        FailedToRefresh: "Rifreskimi dështoi",
        Table: "Tabelë",
        ServiceDataDifferences: "Dallimet e të dhënave të shërbimit",
        ServicesDataDifferences: "Dallimet e të dhënave të shërbimeve",
        RecordsFromDatabases: "Regjistrat nga bazat e të dhënave Admin Web, Service Aggregator dhe Transformations",
        ServiceID: "ID e Shërbimit",
        ServiceId: "ID e Shërbimit",
        Source: "Burimi",
        SyncIn: "Sinkronizo në {{database}}",
        Database: "Baza e të dhënave",
        NoDataDifferencesFoundBetweenAWAndDatabases: "Nuk u gjetën dallime të dhënash mes Admin Web, Service Aggregator dhe Transformations.",
        TransactionRoutesDataDifference: "Dallimet e të dhënave të rrugëve të transaksionit",
        TransactionRoutesDataDifferences: "Dallimet e të dhënave të rrugëve të transaksionit",
        TransactionsRouteID: "ID e rrugës së transaksionit",
        TransactionParameters: "Parametrat e Transaksionit",
        TransactionParametersDataDifference: "Dallimet e të dhënave të parametrave të transaksionit",
        TransactionParametersDataDifferences: "Dallimet e të dhënave të parametrave të transaksionit",
        DatabaseTableRefreshed: "Tabela {{database}} u rifreskua!",
        SyncInDatabaseAddSuccess: "Sinkronizimi në bazën {{database}} u krijua me sukses!",
        SyncInDatabaseAddFail: "Sinkronizimi në bazën {{database}} dështoi!",
        SyncServiceInDatabaseAddSuccess: "Shërbimi në {{database}} u krijua me sukses!",
        SyncTransactionInDatabaseAddSuccess: "Rruga e transaksionit në {{database}} u krijua me sukses!",
        DeleteItemWithName: "Jeni i sigurt që doni të fshini këtë element me emër '{{name}}'?",
        PredefinedTemplateClaimUpdateSuccess: "Kërkesa me model të paracaktuar u përditësua me sukses!",
        PredefinedTemplateClaimAddSuccess: "Kërkesa me model të paracaktuar u krijua me sukses!",
        PredefinedTemplateClaim: "Kërkesë me model të paracaktuar",
        FieldRequired: "{{field}} është e detyrueshme",
        OneClaimRequiredInSingleClaimMode: "Kërkohet saktësisht një kërkesë në modalitetin me një kërkesë",
        PleaseSelectClaim: "Ju lutemi, zgjidhni një kërkesë...",
        CallbackError: "Gabim callback: {{error}}",
        UnauthorizedAccess: "Hyrje e paautorizuar",
        AccessDeniedText: "Qasja u refuzua <br/> Nuk keni leje për këtë faqe. <br/> Ju lutemi kontaktoni administratorin.",
        PageNotFound: "Faqja nuk u Gjet",
        PageNotFoundText: "Faqja që kërkuat nuk u gjet! <br/> Planifikoni postimin tuaj në blog duke zgjedhur një temë.",
        SystemError: "Gabim sistemi",
        SystemErrorText: "Diçka shkoi gabim! <br/> Ju lutemi provoni përsëri më vonë.",
        SetClaimValue: "Caktoni vlerë të kërkesës",
        MissingRoleForTransactionApprove: "Veprim i kufizuar. Roli juaj nuk ka të drejtë të miratojë transaksione",
        GatewayLogs: "Regjistrat e Gateway",
        GatewayLogList: "Lista e regjistrave të Gateway",
        LogMessage: "Mesazhi i regjistrit",
        LogType: "Lloji i regjistrit",
        AuditLevel: "Niveli i auditimit",
        TraceEventType: "Lloji i ngjarjes Trace",
        CreatedAt: "Krijuar më",
        GatewayLogDetails: "Detajet e regjistrit të Gateway",
        ItemRestoreConfirmation: "Jeni i sigurt që doni ta riktheni këtë element me Emrin '{{selectedName}}'?",
        InstitutionRestoredSuccessfully: "Institucioni u rikthye me sukses!",
        ShowDeleted: "Shfaq të fshirë",
        Individual: "Individ",
        Organisation: "Organizatë",
        Agent: "Agjent",
        Spoke: "Degë",
        EmptyClaim: "[Kërkesë bosh]",
        ErrorGettingProfileTypeClaim: "Gabim gjatë marrjes së kërkesës për llojin e profilit: {{error}}",
        NotExistsProfileTypeClaimOrSync: "Nuk  u gjet asnjë kërkesë për llojin e profilit në bazën e të dhënave. Ju lutemi verifikoni që kërkesat janë sinkronizuar saktë nga Keycloak.",
        PleaseSelectAtLeastOneProfileType: "Ju lutemi zgjidhni të paktën një lloj profili",
        RootNodeFailSave: "Rruga e transaksionit u krijua me sukses, por logjika e kërkesës nuk u ruajt",
        RootNodeIsNull: "Rruga e transaksionit u krijua me sukses, por logjika e kërkesës nuk mund të krijohet",
        RemoveRoοt: "Hiq Rrënjën",
        AddRoοt: "Shto Rrënjën",
        CannotRemoveRoot: "Nuk mund ta hiqni rrënjën, ekziston vetëm një element fëmijë",
        MissingRequiredFields: "Ka fusha të detyrueshme që nuk janë plotësuar.",
        LibraryPathAlreadyExists: "Rruga e bibliotekës ekziston tashmë.",
        ClassNames: "Emrat e Klaseve",
        HardDelete: "Fshirje përfundimtare",
        MissingRoleForTransactionHardDelete: "Megjithëse transaksioni është miratuar, roli juaj nuk ka të drejtë të kryejë fshirje përfundimtare.",
        ItemHardDeletionConfirmation: "Jeni i sigurt që doni të fshini përfundimisht këtë element me emrin “{{selectedName}}”?",
        TransactionRouteRestoredSuccessfully: "Rruga e transaksionit dhe të gjithë parametrat e saj u rikthyen me sukses!",
        TransactionRouteHardDeletedSuccessfully: "Rruga e transaksionit dhe të gjithë parametrat e saj u fshinë përfundimisht me sukses!",
        ForbidActionForTransactionApprove: "Kjo rrugë transaksioni është aktualisht në gjendje fshirje të përkohshme dhe nuk mund të miratohet pa u rikthyer më parë.",
        ForbidApprovalActionForTransactionBeforeServiceRestored:  "Shërbimi i kësaj rruge transaksioni është aktualisht i fshirë përkohësisht. Nuk mund të kryhet miratimi derisa shërbimi të rikthehet.",
        ForbidActionsForTransactionsBeforeServiceRestored: "Shërbimi i këtyre rrugëve të transaksioneve është aktualisht i fshirë përkohësisht. Nuk mund të kryhen veprime miratimi ose rikthimi derisa shërbimi të rikthehet.",
        ForbidRestoreActionForTransactionBeforeServiceRestored:  "Shërbimi i kësaj rruge transaksioni është aktualisht i fshirë përkohësisht. Rikthimi nuk mund të kryhet pa rikthyer më parë shërbimin.",
        ForbidCreateActionForTransaction:  "Shërbimi është aktualisht i fshirë përkohësisht. Nuk mund të krijoni rrugë të reja transaksioni derisa shërbimi të rikthehet.",
        ForbidCreateActionForTransactionParams: "Shërbimi ose rruga e transaksionit janë aktualisht të fshira përkohësisht. Nuk mund të krijoni parametra transaksioni derisa të rikthehen.",
        ForbidCopyParamsActionForTransactionParams: "Shërbimi ose rruga e transaksionit janë aktualisht të fshira përkohësisht. Nuk mund të kopjoni parametra transaksioni derisa të rikthehen.",
        ForbidSyncActionForTransactionBeforeServiceTransactionRestored: "Shërbimi ose rruga e transaksionit janë aktualisht të fshira përkohësisht. Sinkronizimi nuk mund të vazhdojë pa rikthyer më parë shërbimin ose rrugën e transaksionit.",
        UserName: "Emri i përdoruesit",
        UserRemoved: "Përdoruesi u fshi",
        FullName: "Emri i plotë",
        UpdateLibrary: "Përditëso Librarinë",
        EditLibrary: "Ndrysho Librarinë",
        LibraryPathNotExists: "Libraria u fshi me sukses, por rruga (path) nuk është e përcaktuar.",
        LibraryDirectoryNotExists: "Libraria u fshi me sukses, megjithatë direktoria e saj nuk ekziston më.",
        DeleteWarningWithStatus: "Libraria u fshi me sukses, por përfundoi me paralajmërime (Status: {{status}}, Mesazhi: '{{data}}').",
        ForbidViewActionForLogs: "Ju nuk keni të drejtat e nevojshme për të parë loget.",
        All: "Të gjitha",
        ClientId: "ID e Klientit SSO",
        Total: "Totali",
        Clients: "Klientët SSO",
        LoginTypes: {
            citizen: "Qytetar",
            business: "Biznes",
            ["entra-id"]: "Entra ID",
            certificate: "Certifikatë",
            ["admin-module"]: "Moduli i administratës"
        },
        SearchBy: "Kërko sipas",
        SearchByTooltip: "Zgjidh ku duhet të përputhet kërkimi: Emri, ID e Aplikacionit të Klientit, ose të dyja.",
        ClientUpdatedSuccessfully: "Klienti SSO u përditësua me sukses!",
        ItemsPerPage: "Artikuj për faqe",
        Filters: "Filtra",
        PredefinedTemplateClaimList: "Lista e kërkesave të modelit të paracaktuar",
        Refresh: "Rifresko",
        ChooseDate: "Zgjidhni një datë",
        Time: "Ora",
        FindProfiles: "Kërkoni profilin",
        SelectAtLeastOneFilter: "Ju lutemi zgjidhni të paktën një filter",
        SetFiltersAndSearch: "Ju lutemi vendosni filtrat më sipër dhe klikoni Kërko për të marrë rezultatet.",
        ProfileState: "Gjendja e profilit",
        Approved: "Miratuar",
        ViewEvents: "Shiko eventet",
        NoDataFound: "Nuk u gjet asnje profil me kriteret e kerkuara.",
        ChooseADate: "Zgjidhni një datë",
        DateRangeInvalid: "Data e mbarimit duhet të jetë e njëjtë ose pas datës së fillimit",
        ActionTypes: "Llojet e veprimeve",
        UserChanges: "Ndryshimet e përdoruesit",
        EventsOfProfileLabel: "Eventet për profilin:",
        ProfileEvents: "Eventet e Profilit",
        MobileNumber: "Numri",
        Email: "Emaili",
        FirstName: "Emri",
        LastName: "Mbiemri",
        UserProfilesList: "Lista e profileve të përdoruesit",
        NoEventsDataFound: "Nuk u gjetën evente që përputhen me kriteret.",
        Exact: "Saktësisht",
        SaveChanges: "Ruaj Ndryshimet",
        ConfirmChanges: "Konfirmo Ndryshimet",
        AboutToUpdateClients: "Ju jeni duke përditësuar {{count}} klient(ë):",
        RemoveFromBatch: "Hiq nga lista",
        ConfirmAndSave: "Konfirmo dhe Ruaj",
        ClientsUpdatedSuccessfully: "{{count}} klient(ë) u përditësuan me sukses",
        SomeUpdatesFailed: "{{count}} përditësim(e) dështuan",
        DeselectAll: "Çzgjidh të gjitha",
        SelectAll: "Zgjidh të gjitha",
        ProfileDetails: "Detajet e profilit",
        ProfileId: "ID i profilit",
        Description: "Përshkrimi",
        LanguageCode: "Kodi i gjuhës",
        UnmanagedClaims: "Kërkesat e pamenaxhuara",
        IsMainUser: "Përdorues kryesor",
        Category: "Kategoria",
        CreatedBy: "Krijuar nga",
        IdpRealm: "Realm i IdP-së",
        Roles: "Rolet",
        Role: "Roli",
        UserType: "Lloji i përdoruesit",
        DeleteUser: "Fshi përdoruesin",
        EditProfile: "Redakto profilin",
        ConfirmDeletion: "Konfirmo fshirjen",
        SureToDeleteUser: "Jeni të sigurt që dëshironi të fshini këtë përdorues?",
        UserDeleteSuccess: "Përdoruesi u fshi me sukses.",
        ActionIrreversible: "Ky veprim është i pakthyeshëm.",
        DisableProfile: "Çaktivizo profilin",
        DisablingPrevents: "Çaktivizimi i këtij profili ndalon autentikimin dhe përdorimin e shërbimeve.",
        Disabling: "Duke çaktivizuar",
        ProfileDisabledSuccessfully: "Profili u çaktivizua me sukses.",
        UndoDisable: "Profili mund të riaktivizohet përmes opsionit 'Aktivizo profilin'.",
        ActivateProfile: "Aktivizo profilin",
        Activating: "Duke aktivizuar",
        ActivatingRestores: "Aktivizimi i këtij profili mundëson autentikimin dhe përdorimin e shërbimeve.",
        ProfileActivatedSuccessfully: "Profili u aktivizua me sukses.",
        ProfileUpdatedSuccessfully: "Profili u përditësua me sukses!",
        ClaimUpdatedSuccessfully: "Atributi u përditësua me sukses!",
        UpdateClaim: "Redakto atributin",
        ProfileIsApproved: "Profili është aprovuar",
        ProfileApprovedSuccessfully: "Profli u aprovua me sukses!",
        ResetPass: "Rivendos fjalëkalimin",
        TemporaryPassword: "Fjalëkalim i përkohshëm",
        ViewProfileClaims: "Shiko të drejtat e profilit",
        CharCount: "8–12 karaktere",
        UppercaseLowercase: "Duhet të përmbajë shkronja të mëdha dhe të vogla",
        AtLeastOneNumber: "Duhet të përmbajë të paktën një numër",
        NoWordPassword: "Nuk duhet të përmbajë fjalën \"password\"",
        ProfileRequiredActions: "Veprimet e kërkuara të profilit",
        ApproveProfile: "Mirato profilin",
        FailedToGetActionLink: "Dështoi marrja e linkut të veprimit",
        FailedToGenerateActionLink: "Dështoi gjenerimi i linkut",
        GeneratedLink: "Link i gjeneruar",
        CopyLink: "Kopjo linkun",
        OpenNewTab: "Hap në një skedë të re",
        TestLink: "Për testim, hapeni këtë link në një dritare incognito/private për të shmangur konfliktet e sesionit.",
        Copied: "Kopjuar!",
        UpdatePassword: "Përditëso fjalëkalimin",
        ConfigureOTP: "Konfiguro OTP",
        VerifyEmail: "Verifiko email-in",
        UnlockUser: "Zhblloko përdoruesin",
        ApprovingWillUnlockUser: "Miratimi i këtij veprimi do të zhbllokojë përdoruesin a bllokuar",
        Approving: "Duke miratuar",
        Confirm: "Mirato",
        GetActionLinks: "Shiko linket e veprimeve",
        UserAlreadyVerified: "Përdoruesi është tashmë i verifikuar",
        LinkSentSuccessfully: "Lidhja u dërgua me sukses!",
        ResendActivationLink: "Ridërgo lidhjen e aktivizimit",
        EmailOnly: "Vetëm Email",
        SmsOnly: "Vetëm SMS",
        EmailAndSms: "Email dhe SMS",
        ResendLink: "Ridërgo lidhjen",
        InvalidProfile: "Profili i pavlefshëm",
        ResetPasswordSmsSent: "SMS për rivendosjen e fjalëkalimit u dërgua",
        ResetPasswordSmsFailed: "Dështoi dërgimi i SMS për rivendosjen e fjalëkalimit",
        SendResetPasswordSms: "Dërgo SMS për rivendosjen e fjalëkalimit",
        ResetPasswordSmsLink: "Link për rivendosjen e fjalëkalimit",
        ResetPassword: "Rivendos fjalëkalimin",
        ManageAccounts: "Menaxhimi i Llogarive",
        ApprovingWillActivate: "A jeni i sigurt që dëshironi të miratoni këtë llogari? Miratimi do ta aktivizojë atë.",
        CreateUser: "Krijo Përdorues",
        UserCreatedSuccessfully: "Përdoruesi u krijua me sukses.",
        MobileNumberAlreadyInUse: "Numri i telefonit celular është tashmë në përdorim.",
        AgentUsersList: "Lista e Përdoruesve Agjentë",
        NewProfile: "Profil i Ri",
        CreateAgentUser: "Krijo Përdorues Agjent",
        CreateProfile: "Krijo Profil",
        ProfileUnlockedSuccessfully: "Profili u zhbllokua me sukses.",
        ProfileNotFound: "Profili nuk u gjet.",
        OTPReset: "Ky veprim do të heqë konfigurimin aktual të OTP. Përdoruesit do t’i kërkohet të konfigurojë sërish aplikacionin e autentifikimit duke skanuar një kod të ri QR në hyrjen e ardhshme.",
        ConfirmOtpUnassignment: "Konfirmo Heqjen e OTP",
        ResetOTPApp: "Rivendos Aplikacionin OTP",
        UnassigningOtp: "Në proces të heqjes së aplikacionit OTP...",
        ProfileActionsInfo: "Zgjidhni nga veprimet më poshtë për të përditësuar kërkesat e sigurisë së përdoruesit. Këto cilësime do të zbatohen në hyrjen e ardhshme të përdoruesit.",
        ConfirmOtpAssignment: "Konfirmo Caktimin e OTP",
        OTPAssignment: "Ky veprim e detyron përdoruesin të konfigurojë një aplikacion të ri autentifikimi. Në hyrjen e ardhshme do të shfaqet një kod QR dhe konfigurimi duhet të përfundohet për të vazhduar.",
        AssignOTPApp: "Cakto Aplikacionin OTP",
        AssigningOTP: "Në proces të caktimit të aplikacionit OTP...",
        OtpAssignedSuccessfully: "Aplikacioni OTP u caktua me sukses.",
        OtpUnassignedSuccessfully: "Aplikacioni OTP u ricaktua me sukses.",
        PassReset: "Ky veprim do të dërgojë me email një fjalëkalim të përkohshëm të gjeneruar automatikisht. Fjalëkalimi aktual do të bëhet i pavlefshëm dhe përdoruesit do t’i kërkohet ta ndryshojë atë në hyrjen e ardhshme.",
        GeneratePass: "Gjenero Fjalëkalim të Përkohshëm",
        SendResetPassSMSInfo: "Ky veprim do të gjenerojë një fjalëkalim të përkohshëm dhe do ta dërgojë atë në numrin e regjistruar të telefonit celular. Fjalëkalimi aktual do të çaktivizohet dhe përdoruesi duhet të vendosë një të ri në hyrjen e ardhshme.",
        ViewProfileDetails: "Shfaq Detajet e Profilit",
        ActionLinks: "Gjenero lidhje të sigurta njëpërdorimshme për verifikimin e email-it, rivendosjen e fjalëkalimit ose konfigurimin e OTP. Kopjojini dhe dërgojini drejtpërdrejt përdoruesit.",
        ViewRoles: "Shfaq Rolet",
        UserRoles: "Rolet e përdoruesit",
        Active: "Aktiv",
        Inactive: "Inaktiv",
        User: "Përdoruesi",
        LinkAlreadySent: "Link është dërguar",
        RolesUpdatedSuccessfully: "Rolet u përditësuan me sukses",
        SomethingWentWrong:"Diçka shkoi keq",
        SystemIdentifiers: "Identifikuesit e sistemit",
        AllowedTransactions: "Transaksionet e Lejuara",
        AllowedTransactionsHint: "Nëse është bosh, ky spoke mund të dërgojë çdo transaksion. Nëse ka vlera, lejohen vetëm ato të zgjedhura.",
        AllowedTransactionsNoneConfigured: "Pa kufizim — ky spoke mund të dërgojë çdo transaksion.",
        AllowedTransactionsUnknown: "i panjohur",
        AllowedTransactionsSelectedCount: "{{count}} të zgjedhura",
        AllowedClassesUpdatedSuccessfully: "Transaksionet e lejuara u përditësuan me sukses.",
        NoResults: "Asnjë rezultat",
        ClearGroup: "Pastro",
        AllowedTransactionsManage: "Menaxho Transaksionet e Lejuara",
        AllowedTransactionsStatusUnrestricted: "Pa kufizim — mund të dërgojë çdo transaksion",
        AllowedTransactionsStatusRestricted: "I kufizuar në {{count}} transaksione në {{services}} shërbime",
        AllowedTransactionsStatusOrphanCount: "{{count}} të panjohura",
        OtpMethod: "Metoda OTP",
        NoProfileIdProvided: "Nuk u dha asnjë ProfileId",       
        UpdateName: "Përditëso Emrin",
        Updating: "Duke u përditësuar...",
        FullNameUpdatedSuccessfully: "Emri i plotë u përditësua me sukses.",
        ErrorUpdatingName: "Ndodhi një gabim gjatë përpjekjes për të përditësuar emrin.",
        HelpDeskOperatorDescription: "Mund të kërkojë, shikojë dhe asistojë profilet e përdoruesve. Të drejta administrative të kufizuara.",
        ManageProfileDescription: "Mund të përditësojë, aktivizojë, çaktivizojë dhe menaxhojë llogaritë e përdoruesve.",
        Assign: "Cakto",
        ManageProfile: "Menaxher Profili",
        HelpDeskOperator: "Operator i HelpDesk",
        TransactionsApprove: "Miratues Transaksionesh",
        AuditLogsViewer: "Shikues i Audit Logs",
        GatewayLogsViewer: "Shikues i Gateway Logs",
        SSOClients: "Menaxhimi i Klientëve SSO",
        ManageServices: "Menaxhimi i Shërbimeve",
        ManageInstitutions: "Menaxhimi i Institucioneve",
        ClaimsViewer: "Shikues i Kërkesave",
        ManageTemplateClaims: "Menaxhimi i Kërkesave me model të paracaktuar",
        TransactionsApproveDescription: "Mund të miratojë një transaksion vetëm një herë.",
        AuditLogsViewerDescription: "Mund të shikojë log-et më të fundit në faqen kryesore, të gjitha log-et në listën e Audit Logs dhe detajet e secilit log individual.",
        GatewayLogsViewerDescription: "Mund të shikojë Gateway Logs dhe detajet e secilit log individual.",
        ClientsDescription: "Mund të aktivizojë ose çaktivizojë opsionet e hyrjes për çdo klient. Përditësimet mund të bëhen individualisht ose në grup.",
        ManageServicesDescription: "Mund të menaxhojë menunë e Shërbimeve.",
        ManageInstitutionsDescription: "Mund të menaxhojë menunë e Institucioneve.",
        ClaimsViewerDescription: "Mund të shikojë detajet e Kërkesave.",
        ManageTemplateClaimsDescription: "Mund të krijojë, editojë dhe fshijë modelet e paracaktuara të kërkesave.",
        Temporarypasswordwasresetsuccessfully: "Fjalëkalimi i përkohshëm u rivendos me sukses",
        Use: "Përdor",      
        EmailAlreadyInUse: "Email-i është tashmë në përdorim.",
        UsernameAlreadyInUse: "Username është tashmë në përdorim.",
        InvalidMobileFormat: "Format i pavlefshëm i numrit të celularit",
        InvalidEmailFormat: "Format i pavlefshëm i email-it",
        FieldIsRequired: "Kjo fushë është e detyrueshme",
        CorrelationIdInvalidFormat: "Ju lutem vendosni ID-në e korrelacionit në formatin e duhur",
        IdInvalidFormat: "Ju lutem vendosni ID-në në formatin e duhur",
        ChangedBy: "Ndryshuar nga",
        SendResetPassSmsInfo: "Dërgon një SMS për rivendosjen e fjalëkalimit te përdoruesi, që përmban një link të sigurt. Përdoruesi mund ta përdorë këtë link për të vendosur një fjalëkalim të ri.",
        RoleChanges: "Ndryshimet e roleve",
        ClearMobileNumber: "Fshi numrin e telefonit",
        MobileNumberWillBeCleared: "Numri i telefonit do të fshihet kur të ruani ndryshimet.",
        WillBeCleared: "Do të fshihet",

        ConsumptionLogs: "Logs të Konsumimit të API-t",
        ConsumptionLogList: "Logs të Konsumimit të API-t",
        ConsumptionLogDetails: "Detaje të Logut",
        ConsumptionReports: "Raporte të Konsumimit të API-t",
        SpokeUserId: "Id e Konsumatorit",
        SpokeName: "Konsumator",
        DownloadPdf: "Shkarko PDF",
        GeneratedAt: "Krijuar më",
        GeneratedBy: "nga",
        Metric: "Treguesi",
        Month: "Muaji",
        ChooseMonth: "Zgjidh muajin",
        Errors: "Gabime",
        CallsThisPeriod: "Thirrje Këtë Periudhë",
        SearchClass: "Shkruaj për të kërkuar klasa...",
        AddClass: "Shto",
        ReportIntro: "Ky raport paraqet të dhënat e konsumit të transaksioneve",
        ForUser: "për përdoruesin",
        ForTransactions: "për shërbimet",
        WithTransactions: "për shërbimet",
        InPeriod: "në periudhën",
        DuringPeriod: "gjatë periudhës",
        Period: "Periudha",
        MonthsShort: "Jan|Shk|Mar|Pri|Maj|Qer|Kor|Gsh|Sht|Tet|Nën|Dhj",
        ConsentId: "Id e Aprovimit",
        SubjectId: "NID/NIPT i Subjektit",
        BackendStatusCode: "Kod Statusi (Backend)",
        GatewayStatusCode: "Kod Statusi (Gateway)",
        ErrorCode: "Kod Gabimi",
        ErrorText: "Mesazh Gabimi",
        ResponseTimeMs: "Koha e Përgjigjes (ms)",
        RequestTimestamp: "Koha e Kërkesës",
        ResponseTimestamp: "Koha e Përgjigjes",
        CallerIp: "IP e Thirrësit",
        TotalCalls: "Thirrje Gjithsej",
        SuccessfulCalls: "Të Suksesshme (2xx)",
        ClientErrorCalls: "Gabim Klienti (4xx)",
        ServerErrorCalls: "Gabim Serveri (5xx)",
        AvgResponseMs: "Mesatare e Përgjigjes (ms)",
        P95ResponseMs: "P95 e Përgjigjes (ms)",
        CallsToday: "Thirrje Sot",
        CallsYesterday: "Thirrje Dje",
        CallsOn: "Thirrje më",
        AvgResponseMsYesterday: "Mesatare e Përgjigjes Dje (ms)",
        AvgResponseMsOn: "Mesatare e Përgjigjes më",
        CallsThisMonth: "Thirrje Këtë Muaj",
        SuccessRate: "Përqindja e Suksesit",
        AvgResponseMsToday: "Mesatare e Përgjigjes Sot (ms)",
        TopSpokes: "Konsumatorët më Aktivë",
        TopClasses: "Transaksionet më të Konsumuara",
        PerSpokeReport: "Sipas Konsumatorit / Transaksionit",
        PerServiceReport: "Sipas Transaksionit",

        ManageRoles: "Menaxher Rolesh",
        ManageRolesDescription: "Mund të krijojë përdorues të Helpdesk-ut si dhe të menaxhojë rolet e tyre.",
        EmailVerifiedSuccessfully: "Email-i u verifikua me sukses.",
        VerifyEmailConfirmation: "Jeni i sigurt që dëshironi të verifikoni email-in e këtij përdoruesi? Verifikimi do të ndryshojë statusin e email-it në të verifikuar.",
        Verifying: "Duke verifikuar email-in...",

        TransactionExplorer: "Eksploruesi i Transaksioneve",
        Transaction: "Transaksioni",
        Endpoint: "Endpoint",
        Successful: "Të suksesshme",
        Failed: "Të dështuara",
        LastExecuted: "Ekzekutimi i fundit",
        LastNDays: "{{count}} ditët e fundit",
        AllTime: "Të gjitha kohërat",
        Window: "Periudha",
        TransactionStatistics: "Statistikat e transaksioneve",
        RecentExecutions: "Ekzekutimet e fundit",
        ExecutionDetails: "Detajet e ekzekutimit",
        NoParameters: "Nuk ka parametra",
        Request: "Kërkesa",
        Response: "Përgjigja",
        RequestResponseTemplate: "Shablloni Kërkesë / Përgjigje",
        NoPayload: "Nuk ka të dhëna",
        Compare: "Krahaso",
        ShowOnlyDifferences: "Shfaq vetëm ndryshimet",
        NoDifferences: "Nuk ka ndryshime",
        DifferencesCount: "{{count}} ndryshim(e)",
        Status: "Statusi",
        Success: "Sukses",
        Caller: "Thirrësi",
        Duration: "Kohëzgjatja",
        StartedAt: "Filloi më",
        Impersonator: "Imitues",
        SelectExecutionHint: "Zgjidhni një ekzekutim për të parë parametrat dhe të dhënat.",
        SeenTimes: "Parë {{count}} herë në periudhë",
        TemplateRank: "Renditja {{rank}}",
        TemplateVariant: "Varianti i shabllonit",
        Pin: "Fikso",
        Unpin: "Hiq fiksimin",
        Pinned: "E fiksuar",
        PinTemplateHint: "Shabllonet e fiksuara ruhen nga procesi i planifikuar edhe nëse dalin nga format më të përdorura.",
        TemplatePinned: "Shablloni u fiksua — do të ruhet në rifreskimet e ardhshme.",
        TemplateUnpinned: "Fiksimi u hoq — mund të zëvendësohet në rifreskimin e ardhshëm.",
        AddTemplate: "Shto shabllon",
        CleanAndAdd: "Pastro & shto",
        AddTemplateHint: "Ngjit një {{direction}} (XML ose JSON). Do të pastrohet njësoj si shabllonet e gjeneruar automatikisht (vlerat zbrazen) dhe do të fiksohet që të ruhet.",
        Manual: "Manual",
        TemplateAdded: "Shablloni u shtua, u pastrua dhe u fiksua.",
        TemplatePayloadInvalid: "Ngjit një payload të vlefshëm XML ose JSON (duhet të fillojë me <, { ose [).",
        NoTemplateAvailable: "Ende nuk ka shabllon",
        CompareWithTemplate: "Krahaso me shabllonin",
        LoadFromExecution: "Ngarko nga ekzekutimi i zgjedhur",
        PastePayloadLabel: "Ngjit një kërkesë ose përgjigje për ta krahasuar me shabllonin",
        PastePayloadPlaceholder: "Ngjit XML ose JSON këtu…",
        YourPayload: "Të dhënat tuaja",
        PasteToCompare: "Ngjit të dhënat lart për t'i krahasuar me shabllonin.",
        Clear: "Pastro",
        StructureCheck: "Kontrolli i strukturës",
        StructureMatches: "Të dhënat përputhen me strukturën e shabllonit.",
        MissingTags: "Mungojnë (në shabllon, jo në të dhëna)",
        ExtraTags: "Shtesë (në të dhëna, jo në shabllon)",
        EmptyValues: "Vlera bosh (të pranishme por bosh)",
        FormatDiffers: "Formati i të dhënave ndryshon nga shablloni — po shfaqet vetëm ndryshimi tekstual.",
        Find: "Kërko",
        FindByCorrelationId: "Kërko sipas Correlation ID",
        TransactionNotFound: "Transaksioni nuk u gjet",

        ProfileEventsHistory: "Historiku i Ngjarjeve të Profilit",
        AdminProfileId: "ID e Profilit të Administratorit",

        Statistics: "Statistika",
        NewUsersStatistics: "Përdorues të Rinj",
        TransactionConsumptionStatistics: "Konsumimi i Transaksioneve",
        TransactionConsumptionStatisticsHint: "Nr. i Transaksioneve ndikon te Koha Mesatare e Transaksionit dhe te Transaksionet P2G/G2G. Emri i Transaksionit ndikon vetëm te Koha Mesatare e Transaksionit.",
        TargetProfileId: "ID e Profilit",
        TrxName: "Emri i Transaksionit",
        NrTrx: "Nr. i Transaksioneve",
        NrTrxPlaceholder: "Lëreni bosh për të përfshirë të gjitha",
        NrTrxTooLow: "Vlera duhet të jetë numër i plotë më i madh ose i barabartë me {{min}}.",
        AverageTrxTimeNote: "Kufizuar te {{count}} transaksionet e para",
        AverageTrxTimeNoteUnlimited: "Përfshin të gjitha transaksionet për periudhën e zgjedhur",
        StatisticsDateRangeRequired: "Ju lutemi plotësoni të paktën datën e fillimit dhe datën e mbarimit para kërkimit.",
        TotalUsers: "Përdorues Gjithsej",
        NewUsersRatio: "Përqindja e Përdoruesve të Rinj",
        AverageTrxTime: "Koha Mesatare e Transaksionit",
        P2GTransactions: "Transaksione P2G",
        G2GTransactions: "Transaksione G2G",
        TotalTransactions: "Transaksione Gjithsej",
        NrOfTrxForUser: "Transaksione për Profilin",
        NrOfLoginsForUser: "Hyrje për Profilin",
        UserCountByProfileType: "Përdoruesit sipas Tipit të Profilit",
        NoData: "Pa të dhëna",
        StatisticsProfileNotFound: "Nuk u gjet asnjë profil me ID '{{profileId}}'.",

    }
};

export default al;